import { render, staticRenderFns } from "./Agent.vue?vue&type=template&id=23dc028a&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23dc028a')) {
      api.createRecord('23dc028a', component.options)
    } else {
      api.reload('23dc028a', component.options)
    }
    module.hot.accept("./Agent.vue?vue&type=template&id=23dc028a&lang=pug&", function () {
      api.rerender('23dc028a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Agent.vue"
export default component.exports